import {
  AdMob,
  AdmobConsentStatus,
  BannerAdPosition,
  BannerAdSize,
  MaxAdContentRating,
} from '@capacitor-community/admob'
import { Capacitor } from '@capacitor/core'

const googleAndroidTestBannerId = 'ca-app-pub-3940256099942544/9214589741'
const configuredBannerId = import.meta.env.VITE_ADMOB_BANNER_ID?.trim()
const bannerAdId = configuredBannerId || googleAndroidTestBannerId
const isTesting = !configuredBannerId

let initialized = false

export async function initializeAdMobBanner(): Promise<boolean> {
  if (!Capacitor.isNativePlatform() || initialized) return initialized

  await AdMob.initialize({
    initializeForTesting: isTesting,
    tagForChildDirectedTreatment: false,
    tagForUnderAgeOfConsent: false,
    maxAdContentRating: MaxAdContentRating.General,
  })

  let consentInfo = await AdMob.requestConsentInfo({
    tagForUnderAgeOfConsent: false,
  })

  if (consentInfo.isConsentFormAvailable && consentInfo.status === AdmobConsentStatus.REQUIRED) {
    consentInfo = await AdMob.showConsentForm()
  }

  if (!consentInfo.canRequestAds) return false

  await AdMob.showBanner({
    adId: bannerAdId,
    adSize: BannerAdSize.ADAPTIVE_BANNER,
    position: BannerAdPosition.BOTTOM_CENTER,
    margin: 66,
    isTesting,
    npa: true,
  })

  document.documentElement.classList.add('has-native-ad')
  initialized = true
  return true
}

export async function showAdPrivacyOptions(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return
  await AdMob.showPrivacyOptionsForm()
}
